import { Avatar, AvatarFallbackText, AvatarImage, HStack, Text } from '@vidahealth/vida-ui';

import type { MatchedCoach } from '@/modules/api';

import { coachDisplayName } from './coachDisplayName';

function initialsOf(name: string): string {
  return name
    .split(' ')
    .map((part) => part[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('');
}

/**
 * Shared coach header (avatar + label) used across the coach-selection screens
 * (availability, quick-intro). Addresses the coach via `coachDisplayName`
 * (displayName, or first name + title when it's empty).
 */
export function CoachSummary({
  coach,
}: {
  coach: Pick<MatchedCoach, 'displayName' | 'firstName' | 'title' | 'image'>;
}) {
  const label = coachDisplayName(coach);
  return (
    <HStack space='md' className='items-center'>
      <Avatar size='lg'>
        <AvatarFallbackText>{initialsOf(label)}</AvatarFallbackText>
        {coach.image ? <AvatarImage source={{ uri: coach.image }} alt={label} /> : null}
      </Avatar>
      <Text size='md' weight='bold' className='text-typography-900'>
        {label}
      </Text>
    </HStack>
  );
}
